module.exports = __webpack_public_path__ + "media/sub7-3-1.f7ec516a.mp4";